import React from "react";

export default function PageHeaderBlock({ id, type, kicker, title, description }) {
  return (
    <header className="pt-10 text-center col-12 col-sm-9 col-lg-7 col-xl-6 mx-auto">
      {kicker && <p className="section-kicker mb-3">{kicker}</p>}
      {title && <h1 className="section-heading mx-auto mb-3">{title}</h1>}
      {description && <p className="text-muted lead mb-0">{description}</p>}
    </header>
  );
}
